export function DiamondMark({ size = 32, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}
      xmlns="http://www.w3.org/2000/svg" aria-label="Virtus Diamond Registry seal" role="img">
      <circle cx="24" cy="24" r="22.2" fill="none" stroke="#c9a84c" strokeWidth="1" opacity="0.55" />
      <circle cx="24" cy="24" r="19" fill="none" stroke="#c9a84c" strokeWidth="0.6" opacity="0.35" />
      <path d="M16 13 H32 L39 21 L24 39 L9 21 Z" fill="none" stroke="#c9a84c" strokeWidth="1.3" />
      <path d="M16 13 L24 21 L32 13" fill="none" stroke="#c9a84c" strokeWidth="1" />
      <path d="M9 21 H39" stroke="#c9a84c" strokeWidth="1" />
      <path d="M24 21 L24 39" stroke="#c9a84c" strokeWidth="0.8" opacity="0.7" />
      <path d="M16 13 L9 21 L24 39 L16 21 Z" fill="#c9a84c" opacity="0.10" />
      <path d="M32 13 L39 21 L24 39 L32 21 Z" fill="#c9a84c" opacity="0.18" />
    </svg>
  );
}

export function Logo({ size = 32, showText = true, sub = true }) {
  return (
    <div className="flex items-center gap-3 select-none">
      <DiamondMark size={size} />
      {showText && (
        <div className="leading-none">
          <div className="font-serif tracking-tight text-bb-text"
            style={{ fontSize: size * 0.5, fontWeight: 600 }}>
            Virtus <span className="text-bb-gold">Registry</span>
          </div>
          {sub && (
            <div className="text-bb-gold uppercase tracking-[0.26em] mt-1"
              style={{ fontSize: Math.max(8, size * 0.19) }}>
              The American Provenance Standard
            </div>
          )}
        </div>
      )}
    </div>
  );
}
